import cx from 'classnames'
import { ComponentType, HTMLAttributes } from 'react'

export const Separator: ComponentType<HTMLAttributes<HTMLDivElement>> = ({ className, style = {}, ...props }) => {
  return <div className={cx('bg-athens-gray-2', className)} style={{ height: 1, ...style }} {...props} />
}
